export default __webpack_public_path__ + "static/media/FSKoopman-Light.0a9c51fb.woff2";